import { isBefore, startOfDay } from "date-fns";
import React, { useCallback } from "react";
import { Icon, Pressable } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { MeetingRoomDateRangePicker } from "./meeting_room_date_range_picker";
import { MeetingRoomDateRange } from "./order_params";

interface MeetingRoomDateTimePickerProps {
  onChangeDateRange: (dateRange?: MeetingRoomDateRange) => void;
  onClearFilter: () => void;
  dateRangeValue?: MeetingRoomDateRange;
  minStartTime?: string;
  maxEndTime?: string;
  timeSlotIncrement?: number;
  view: "modal" | "dialog";
}

export function MeetingRoomDateTimePicker(
  props: MeetingRoomDateTimePickerProps
) {
  const {
    onChangeDateRange,
    onClearFilter,
    dateRangeValue,
    view,
    minStartTime,
    maxEndTime,
    timeSlotIncrement,
  } = props;

  const isOutsideRange = useCallback((date: Date) => {
    return isBefore(date, startOfDay(new Date()));
  }, []);

  const { fbt, locale } = useI18n();
  const pickerOverride = {
    view: {
      style: {
        border: "1px solid #D7D5DD",
        borderRadius: 5,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 8,
      },
    },
  };

  return (
    <div
      className={
        "mr-date-picker-container " + (dateRangeValue?.date ? "has-data" : "")
      }
    >
      <MeetingRoomDateRangePicker
        firstDayOfWeek={0}
        view={view}
        ctaTitle={fbt("Save")}
        placeholder={fbt("Date")}
        value={dateRangeValue}
        onComplete={onChangeDateRange}
        onNextVisibleDates={() => {}}
        onSelectDate={() => {}}
        isOutsideRange={isOutsideRange}
        override={pickerOverride}
        isRequiredTimeRange={true}
        numberOfMonths={1}
        minStartTime={minStartTime}
        maxEndTime={maxEndTime}
        timeSlotIncrement={timeSlotIncrement}
      />
      {view === "dialog" && dateRangeValue?.date && (
        <Pressable
          style={{
            position: "absolute",
            top: 8,
            ...(locale.direction === "ltr" ? { right: 16 } : { left: 31 }),
          }}
          onPress={() => onClearFilter()}
        >
          <div className="picker-view-clear">
            <Icon name="x" size={14} />
          </div>
        </Pressable>
      )}
    </div>
  );
}
